import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full mb-6" }
const _hoisted_2 = { class: "text-xl text-center mb-3 text-green-400" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = { class: "font-semibold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, [
      _createTextVNode(_toDisplayString(_ctx.$t("parcels.list.actions.modal_content.labels_success")), 1),
      _hoisted_3,
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.accountDetails.contact_email), 1)
    ])
  ]))
}